import Axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function CreateAgentService(data, token) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(data);
      const response = await Axios.post(
        `${URL_AUTH}/api/admin/v1/agent/create`,
        data,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      resolve(response);
    } catch (error) {
      reject(error);
      console.log(error);
    }
  });
}
